<script lang="ts">
	import { t } from "@hitit/hub/src/stores";
	import { DefaultCheckbox } from "@hitit/new_ui/src";
	export let articles = "";
	export let checked = false;

</script>

<div id="createstore-term-container">
	<div class="term-header">
		<strong class="white"> {$t('hub.create_store.store_member_terms')} </strong>
		<p>{$t('hub.create_store.confirmation_and_consent')}</p>
	</div>
	<div class="term-box">
		<p class="term">
			{@html articles}
		</p>
	</div>
	<div class="agree-box">
		<div class="checkbox">
			<DefaultCheckbox bind:checked id={'checkbox'} />
		</div>
		<label for="checkbox">
			{$t('hub.create_store.over_14')}
			<span>{$t('hub.create_store.term_names')}</span>
			{$t('hub.create_store.i_agree')}
		</label>
	</div>
	<empty />
	<slot />
</div>

<style lang="scss">
	@import "../../variables.scss";
	#createstore-term-container {
		.white {
			color: white;
		}
		.term-header {
			display: flex;
			flex-direction: column;
			gap: 10px;
			strong {
				font-size: 1.25rem;
				font-weight: 500;
			}
			p {
				color: var(--lightGrey);
				line-height: 1.125rem;
			}
		}
		.term-box {
			margin-top: 26px;
			background-color: white;
			height: 300px;
			max-height: 300px;
			padding: 6px 10px 0px 10px;
			border-radius: 5px;
		}

		p.term {
			height: 100%;
			overflow: auto;
			line-height: 25px;
			box-sizing: border-box;
			//IE , Firefox not supported
			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}
		}
		.agree-box {
			display: flex;
			margin-top: 20px;
			gap: 10px;
			align-items: center;
			.checkbox {
				min-width: 41.2px;
				height: 41.2px;
			}
			label {
				flex-grow: 1;
				line-height: 1.125rem;
				color: white;
				transition: color 0.15s;

				&:hover {
					cursor: pointer;
					color: #e7e9eb;

					span {
						color: #5991ff;
					}
				}
				span {
					transition: color 0.15s;
					color: #a5c1f9;
				}
			}
		}
		empty {
			display: block;
			height: 40px;
		}
	}

	@include DesktopSize {
		#createstore-term-container {
			.term-header {
				p {
					font-size: 1.125rem;
				}
			}
			.term-box {
				margin-top: 29.8px;
				height: 400px;
				max-height: 400px;
				padding: 6px 12.5px 0px 12.5px;
			}

			.agree-box {
				display: flex;
				margin-top: 16px;
				gap: 20px;
				align-items: center;
				.checkbox {
					min-width: 30px;
					height: 30px;
				}
				label {
					font-size: 1.125rem;
				}
			}
			empty {
				height: 50px;
			}
		}
	}

</style>
